<section>
	<custom-select [required]="true"
				   [selectList]="brands"
				   [(value)]="brandId"
				   [label]="'company.domains.request-transfer.choose-brand' | translate"
				   [allowAutoFocus]="false" />
	<custom-select [required]="true"
				   [allowAutoFocus]="false"
				   [selectList]="availableVariants"
				   [(value)]="selectedVariant"
				   [label]="'company.domains.new-product-plan.select-product-variant.label' | translate" />

	<custom-input [label]="'company.domains.new-product-plan.select-product-variant.price' | translate" type="currency" [(value)]="price" [disabled]="isTldDk" [required]="!isTldDk" />
</section>
